













import {Component, Prop, Vue} from "vue-property-decorator";
import {IFilm} from "@/interfaces/film.interface";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";

@Component({})
export default class RelatedBox extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  routePath = RouterStore.ROUTE_PATH;

  @Prop() card: IFilm;
  @Prop() active: boolean;

  async clickRelatedBox() {
    if (this.active) {
      await this.$store.dispatch('routerStore/openFilmPage', this.card.entity_id);
    }
  }
}
